var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerritory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M4 1h5M3 2h1m5 0h1M2 3h1m7 0h1M1 4h1m9 0h1M1 5h1m9 0h1M1 6h1m9 0h1M1 7h1m9 0h1M1 8h1m9 0h1M2 9h1m7 0h1m-8 1h1m5 0h1m-6 1h5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4eaf2d",
    d: "M4 2h1m2 0h2M3 3h2m1 0h1M2 4h2M2 5h1M2 6h1M2 8h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292f7e",
    d: "M5 2h2M5 3h1M4 4h1M3 5h1M3 6h1M2 7h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#287f2b",
    d: "M7 3h2M5 4h4M4 5h2m1 0h2M5 7h3M3 8h1m1 0h2M3 9h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#16592d",
    d: "M9 3h1M9 4h2M9 5h2M9 6h1M8 7h1M7 8h1M6 9h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#05117f",
    d: "M6 5h1M4 6h5M3 7h2M4 8h1M4 9h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000054",
    d: "M10 6h1M9 7h2M8 8h3M8 9h2m-6 1h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritory);
export default __webpack_public_path__ + "static/media/territory.36284ff6ec47798576d141e0f926efe5.svg";
export { ForwardRef as ReactComponent };